//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import firebase from "firebase";
export default {
  name: "Login",

  data() {
    return {
      email: "",
      password: "",
      error: "",
    };
  },
  computed: {},
  methods: {
    handleFacebookLogin() {
      var provider = new firebase.auth.FacebookAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((userCredential) => {
          console.log(userCredential);
          this.$router.replace({ name: "Classes" });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleGoogleLogin() {
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((userCredential) => {
          console.log(userCredential);
          this.$router.replace({ name: "Classes" });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleEmailLogin(email, password) {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((userCredential) => {
          console.log(userCredential);
          this.error = "";
          this.$router.replace({ name: "Classes" });
        })
        .catch((error) => {
          console.log(error);
          this.error =
            "Sorry, we couldn't find an account with that email and password.";
        });
    },
  },
  mounted() {},
};
